export const EXPERIMENT_VARIATION = {
  DEFAULT: 'default',
  KEVEL: 'kevel',
  V1: 'v1',
  V2: 'v2',
  V3: 'v3',
  V4: 'v4',
  V5: 'v5',
} as const

export type EXPERIMENT_VARIATION =
  (typeof EXPERIMENT_VARIATION)[keyof typeof EXPERIMENT_VARIATION]
